module.exports = __webpack_public_path__ + "img/17.a9869e19.jpg";